import { render, staticRenderFns } from "./ProjectManagerEdit.vue?vue&type=template&id=ed37a590&scoped=true&"
import script from "./ProjectManagerEdit.vue?vue&type=script&lang=ts&"
export * from "./ProjectManagerEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed37a590",
  null
  
)

export default component.exports